import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useFamilyAuth } from '../../contexts/FamilyAuthContext';
import FamilyNavigation from './FamilyNavigation';

/**
 * Family Layout - Cookie-based Auth (Refactored)
 * Protected Layout für authentifizierte Family Users
 * Phase 17: Onboarding Guard
 */
function FamilyLayout() {
  const { familyUser, loading, isAuthenticated } = useFamilyAuth();

  // Loading state - checking cookie session
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-950">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#6DCEE8] mx-auto mb-4"></div>
          <p className="text-[#CBD5F5]">Authentifizierung wird geprüft...</p>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!isAuthenticated || !familyUser) {
    console.log('⚠️ Not authenticated, redirecting to login');
    return <Navigate to="/family/login" replace />;
  }

  // Phase 17: Onboarding Guard
  // Redirect to onboarding if user hasn't completed it
  if (familyUser.has_completed_onboarding === false) {
    console.log('⚠️ Onboarding not completed, redirecting');
    return <Navigate to="/onboarding" replace />;
  }

  console.log('✅ Authenticated as:', familyUser.email);

  return (
    <div className="family-app">
      <Outlet />
      <FamilyNavigation />
    </div>
  );
}

export default FamilyLayout;
